//import $ from 'imports/jquery'
import stickCommon from 'site/stick.common';
let stickGlobal = {
    init: function () {
        $('.global-hover-js.toggle .label').on('click',stickGlobal.globalHoverJSToggle)
        $('.global-hover-js.leave').on('mouseleave',stickGlobal.globalHoverJSClose)
        $('.global-hover-js.enter .label').on('mouseenter',stickGlobal.globalHoverJSOpenEvent)
        $('.global-hover-js.click-open .label').on('click',stickGlobal.globalHoverJSOpenEvent)

        $('.global-search .search-icon').on('click',stickGlobal.globalSearchSubmitClick)
        $('.global-search .search-field').on('click',stickGlobal.globalSearchSubmitEnter)
        $('.global-search form').on('submit',stickGlobal.globalSearchSubmitEvent)
    },
    ////////////////////////////////////////////////////////////////////////////////////
    // HOVER PANELS
    globalHoverJSToggle: function() {
        let elem = $(this).parent()
        if (elem.hasClass('open')) {
            stickGlobal.globalHoverJSClose()
        } else {
            stickGlobal.globalHoverJSOpen(elem)
        }
    },
    globalHoverJSClose: function () {
        $('.global-hover-js').removeClass('open')
    },
    globalHoverJSOpenEvent: function () {
        let elem = $(this).parent()
        stickGlobal.globalHoverJSOpen(elem)
    },
    globalHoverJSOpen: function (elem) {
        elem.addClass('open')
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // SEARCH
    globalSearchSubmitClick: function() {
        let form = $(this).closest( "form" )
        console.log(form)
        if (form) {
            form.submit()
        }
    },
    globalSearchSubmitEnter: function(event) {
        let keyCode = (event.keyCode ? event.keyCode : event.which);
        if(keyCode === 13){
            let form = $(this).closest( "form" )
            if (form) {
                form.submit()
            }
        }
    },
    globalSearchSubmitEvent: function(e) {
        let searchValue = $('.search-field', e.target).val().trim()
        return (searchValue !== '')
    },

}
export default stickGlobal
